import _ from "lodash";

export const orderObjectByProperty = (object, propertyName, order) => {
    return _.orderBy(object,
        [function(o) { return o[propertyName]; }], order);
}


